module.exports = __webpack_public_path__ + "media/turn-right.c961f581.mp3";